export const storeData = {

  state: {
    token_session: null,
    authenticated: false,
    loading: false,
    usuario: {},
    menu_option: 'Home',
    snackbars: [],
    routesPermitted: [],
    menu: [],
    menu_fijo: [
      {
        label: 'Cerrar sesión',
        isMenu: false,
        action: 1,
        icon: 'exit_to_app'
      }
    ],
    permissions:[]
  },
  mutations: {
    token_session(state, n) {
      state.token_session = n;
    },
    usuario: (state, usuario) => {
      state.usuario = usuario
      state.authenticated = !!usuario.id
    },
    menu: (state, menu) => {
      state.menu = menu.concat(state.menu_fijo)
    },
    permissions: (state, permissions) => {
      state.permissions = permissions
    },
    loading: (state, to) => {
      state.loading = to
    },
    set_menu_option: (state, option) => {
      state.menu_option = option
    },
    SET_SNACKBAR: (state, snackbar) => {
      state.snackbars = state.snackbars.concat(snackbar)
    }
  },
  actions: {
    authenticate: () => {
      if (!localStorage.token) return Promise.reject()
      // Load the user and return the result promise
      const baseUrl = process.env.NODE_ENV === 'development'
        ? 'http://127.0.0.1:8000/api'
        : '/api'
      const headers = {'Authorization': `Bearer ${localStorage.token}`}
      return axios.get(`${baseUrl}/me`, {headers})
    },
    setSnackbar({commit}, snackbar){
      snackbar.showing = true
      snackbar.type = snackbar.type || 'success'
      commit('SET_SNACKBAR', snackbar)
    }
  }

};